import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UserService } from '../../../services/user.service';
import { UserBaseModel } from '@core/api';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import { FormService } from '@core/services';
import { UserModel } from '@core/api/model/userModel';

@Component({
  selector: 'user-information-edit',
  templateUrl: './user-information-edit.component.html',
  styleUrls: ['./user-information-edit.component.scss']
})
export class UserInformationEditComponent implements OnInit {

  @Input() user: UserBaseModel;
  @Output() onChanged = new EventEmitter<UserBaseModel>();
  @Output() onNoChanged = new EventEmitter<boolean>();
  loading: boolean = false;
  userInformationForm: FormGroup;
  constructor(
    private formBuilder: FormBuilder,
    private formService: FormService,
    public userService: UserService
  ) { }

  initUser() {
    this.loading = false;

    this.userInformationForm = this.formBuilder.group({
      id: [this.user.id],
      email: [this.user.email],
      last_name: [this.user.last_name],
      first_name: [this.user.first_name],
      patronymic_name: [this.user.patronymic_name],
      phone_number: [this.user.phone_number],
    });

  }

  ngOnInit() {
    this.initUser();
  }

  submit() {
    this.loading = true;

    this.formService.markFormGroupTouched(this.userInformationForm);

    if (this.userInformationForm.invalid) {
      return this.loading = false;
    }

    const userModel = {...this.userInformationForm.value};
    this.onChanged.emit(userModel);
  }

  return(){
    this.onNoChanged.emit(true);
  }
}
